import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell as MUITableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import MUITableHeadCell from "./../../components/TableHeadCell.js";
import { green } from "@mui/material/colors";

const TableCell = styled(MUITableCell)({
  overflowWrap: "anywhere",
  wordBreak: "normal"
});

const TableHeadCell = styled(MUITableHeadCell)({
  paddingTop: 6,
  paddingRight: 0,
  paddingBottom: 6,
  paddingLeft: 16,
});

const StatusBagde = ({ active }) => {
  const props = active ? ({
    label: "Active", sx: { color: green[900], backgroundColor: "#2E7D324D" }
  }) : { label: "Inactive", color: "default" }

  return <Chip {...props} />
}

const BidderRow = ({ id, name, active, url, onEditClick }) => (
  <TableRow hover>
    <TableCell>{id}</TableCell>
    <TableCell>{name}</TableCell>
    <TableCell>{url}</TableCell>
    <TableCell><StatusBagde active={active} /></TableCell>
    <TableCell variant="body" align="right">
      <IconButton aria-label="edit" size="small" onClick={onEditClick(id)}>
        <EditOutlinedIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

const BiddersList = ({
  bidders,
  onSortOrderChange,
  onPageChange: handlePageChange,
  onRowsPerPageChange: handleRowsPerPageChange,
  page,
  rowsPerPage,
  totalCount,
  orderBy,
  orderDirection
}) => {
  const navigate = useNavigate();
  const onEditClick = (id) => () => navigate(`/programmatic_supply/bidders/${id}/edit`);

  return (
    <Box
      style={{ style: "width: 100%" }}
      sx={{ boxShadow: "0 0 0 1px #E0E0E0", borderRadius: 1 }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="id"
                title="ID"
                align="left" />
              <TableHeadCell
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="name"
                title="Name"
                align="left" />
              <TableHeadCell
                onSortOrderChange={onSortOrderChange}
                orderBy={orderBy}
                orderDirection={orderDirection}
                name="active"
                title="Endpoint URL"
                align="left" />
              <MUITableCell align="left">Status</MUITableCell>
              <MUITableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {bidders.map((config) => (
              <BidderRow
                onEditClick={onEditClick}
                {...config}
                key={config.id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalCount}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[25, 50, 100]}
        SelectProps={{ native: true }}
      />
    </Box>
  );
};

export default BiddersList;
